export const socks = {
  msrp: 15.99,
  variants: [['knee-high', 'crew']],
  infoLink: 'https://www.teamtriton.com/custom-socks.html',
  items: [
    {
      number: 'SK099',
      hasModel: false,
    },
    {
      number: 'SK100',
      hasModel: false,
    },
    {
      number: 'SK101',
      hasModel: false,
    },
    {
      number: 'SK102',
      hasModel: false,
    },
    {
      number: 'SK103',
      hasModel: false,
    },
    {
      number: 'SK104',
      hasModel: false,
    },
    {
      number: 'SK105',
      hasModel: false,
    },
    {
      number: 'SK106',
      hasModel: false,
    },
    {
      number: 'SK107',
      hasModel: false,
    },
    {
      number: 'SK108',
      hasModel: false,
    },
    {
      number: 'SK109',
      hasModel: false,
    },
    {
      number: 'SK110',
      hasModel: false,
    },
    {
      number: 'SK111',
      hasModel: false,
    },
    {
      number: 'SK112',
      hasModel: false,
    },
    {
      number: 'SK113',
      hasModel: false,
    },
    {
      number: 'SK114',
      hasModel: false,
    },
    {
      number: 'SK115',
      hasModel: false,
    },
    {
      number: 'SK116',
      hasModel: false,
    },
  ],
};
